import React from "react";
import { Chip, Stack } from "@mui/material";
import { markerBadges, railMarkerBadges } from "./regmFormat";
import { amberChipSx } from "./regmColors";
import HelpTip from "./HelpTip";
import { MARKER_HELP } from "./helpText";

// Labels may wrap so the History table can get narrower.
const wrapLabel = { height: "auto", "& .MuiChip-label": { whiteSpace: "normal", py: 0.25 } };

// Unavailable (old-format data) is outlined; a true marker is highlighted; false is neutral.
// hideNo drops only strict "No" markers: true ones show their name, Unavailable stays labelled.
// badges (optional) renders an already computed list instead of reading source.
// help adds an info tooltip beside each chip (tipPlacement moves it away from controls below).
const MarkerChips = ({ source, hideNo = false, badges: given, help = false, tipPlacement }) => {
  const badges = given || (hideNo ? railMarkerBadges(source) : markerBadges(source));
  if (badges.length === 0) return null;
  return (
    <Stack direction="row" spacing={0.5} useFlexGap flexWrap="wrap">
      {badges.map((b) => {
        const chip = (
          <Chip
            size="small"
            label={hideNo && b.value === "Yes" ? b.label : `${b.label}: ${b.value}`}
            variant={b.value === "Yes" ? "filled" : "outlined"}
            sx={{ ...wrapLabel, ...(b.value === "Yes" ? amberChipSx : {}) }}
          />
        );
        if (!help || !MARKER_HELP[b.key]) return React.cloneElement(chip, { key: b.key });
        return (
          <Stack key={b.key} direction="row" alignItems="center">
            {chip}
            <HelpTip text={MARKER_HELP[b.key]} label={b.label} placement={tipPlacement} />
          </Stack>
        );
      })}
    </Stack>
  );
};

export default MarkerChips;
